import { apiClient } from "@/lib/api-client";
import type { FavoriteItem, FavoritesResponse } from "@/types/api";

export type ServerFavoriteItem = FavoriteItem;

export const favoritesApi = {
  getFavorites: () => apiClient.get<FavoritesResponse>("/favorites"),
  addItem: (productId: string) =>
    apiClient.post<FavoritesResponse>("/favorites/items", { productId }),
  removeItem: (productId: string) => apiClient.del<void>(`/favorites/items/${productId}`),
  clearFavorites: () => apiClient.del<void>("/favorites"),
};
